import { jsxs as r, jsx as o } from "react/jsx-runtime";
import L from "../svg-icon/svg-icon.component.js";
function h(t) {
  return /* @__PURE__ */ r(L, { width: "24", height: "24", viewBox: "0 0 24 24", ...t, children: [
    /* @__PURE__ */ o("path", { d: "M18.8711 4.06423L4 18.8776L5.12681 20L19.9979 5.18667L18.8711 4.06423Z" }),
    /* @__PURE__ */ o("path", { d: "M4.00212 5.12245L18.8732 19.9358L20 18.8134L5.12893 4.00002L4.00212 5.12245Z" })
  ] });
}
export {
  h as CloseIcon
};
//# sourceMappingURL=close.js.map
